import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { updateEntities, deleteEntity } from 'redux-modules/entity'

import api from 'api'

const FETCH_REQUEST = 'realhub/taskListItem/FETCH_REQUEST'
const FETCH_SUCCESS = 'realhub/taskListItem/FETCH_SUCCESS'
const FETCH_FAILURE = 'realhub/taskListItem/FETCH_FAILURE'
const CREATE_REQUEST = 'realhub/taskListItem/CREATE_REQUEST'
const CREATE_SUCCESS = 'realhub/taskListItem/CREATE_SUCCESS'
const CREATE_FAILURE = 'realhub/taskListItem/CREATE_FAILURE'
const UPDATE_REQUEST = 'realhub/taskListItem/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'realhub/taskListItem/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'realhub/taskListItem/UPDATE_FAILURE'
const DELETE_REQUEST = 'realhub/taskListItem/DELETE_REQUEST'
const DELETE_SUCCESS = 'realhub/taskListItem/DELETE_SUCCESS'
const DELETE_FAILURE = 'realhub/taskListItem/DELETE_FAILURE'

const SELECT_TASKLISTITEM = 'realhub/taskListItem/SELECT_TASKLISTITEM'

// Initial State
const initialState = {
  creating: false,
  deleting: false,
  errors: [],
  loading: false,
  selectedId: null,
  updating: false,
}

// Actions
export function fetchRequest(){
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(){
  return {
    type: FETCH_SUCCESS,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(){
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(){
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

export function deleteRequest(){
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess(payload = {}){
  return {
    type: DELETE_SUCCESS,
    result: payload.result,
  }
}

export function deleteFailure(errors = []){
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

export function selectTaskListItem(taskListItem = {}){
  return (dispatch) => {
    dispatch({
      type: SELECT_TASKLISTITEM,
      selectedId: taskListItem.id,
    })
  }
}

export function hydrateTaskListItem(taskListItem){
  return (dispatch) => {
    if (taskListItem.id){
      const normalizedJson = normalize(taskListItem, Schemas.TASK_LIST_ITEM)
      dispatch(updateEntities(normalizedJson))
    }
  }
}

// HELPER FUNCTIONS
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function loadTaskListItems(options){
  return (dispatch) => {
    // Set Loading
    dispatch(fetchRequest())

    const promise = api('/agency/task_list_items.json', options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.TASK_LIST_ITEM_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))
        return { success: false, result: errors }
      })

    return promise
  }
}

export function createTaskListItem(taskListItem, options, callback){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      task_list_item: taskListItem,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(createRequest())

    const promise = api(`/agency/task_lists/${taskListItem.task_list_id}/items.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.TASK_LIST_ITEM)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        if (callback) callback(json)

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(createFailure(errors))
        return { success: false, result: errors }
      })

    return promise
  }
}

export function updateTaskListItem(taskListItem, options, callback){
  const config = {
    method: 'PUT',
    body: JSON.stringify({
      task_list_item: taskListItem,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(updateRequest())

    const { task_list_id, id } = taskListItem
    const promise = api(`/agency/task_lists/${task_list_id}/items/${id}.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.TASK_LIST_ITEM)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        if (callback) callback(json)

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

export function updateTaskListItemSortOrder(taskListSection, itemIds, options){
  const config = {
    method: 'PUT',
    body: JSON.stringify({
      sort_order: itemIds,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(updateRequest())

    const { task_list_id } = taskListSection
    const promise = api(`/agency/task_lists/${task_list_id}/items/update_sort_order.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.TASK_LIST_ITEM_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))
        return { success: false, result: errors }
      })

    return promise
  }
}

export function toggleTaskListItemStatus(taskListItem, options, callback){
  const config = {
    method: 'PUT',
  }

  return (dispatch) => {
    // Set Loading
    dispatch(updateRequest())

    const { task_list_id, id } = taskListItem
    const promise = api(`/agency/task_lists/${task_list_id}/items/${id}/toggle_completion.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.TASK_LIST_ITEM)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        if (callback) callback(json)

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))
        return { success: false, result: errors }
      })

    return promise
  }
}

export function performTaskListItemAction(taskListItem, options){
  const { id, task_list_id } = taskListItem

  const config = {
    method: 'POST',
    body: JSON.stringify({
      task_list_item: taskListItem,
    }),
  }

  return () => {
    const promise = api(`/agency/task_lists/${task_list_id}/items/${id}/perform_action.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        return { success: false, result: errors }
      })

    return promise
  }
}

export function deleteTaskListItem(taskListItem, options){
  const config = {
    method: 'DELETE',
  }

  return (dispatch) => {
    // Set Loading
    dispatch(deleteRequest())

    const promise = api(
      `/agency/task_lists/${taskListItem.task_list_id}/items/${taskListItem.id}.json`,
      options,
      config,
    ) // eslint-disable-line max-len
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.TASK_LIST_ITEM)
        dispatch(deleteEntity(normalizedJson))
        dispatch(deleteSuccess())

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(deleteFailure(errors))
        return { success: false, result: errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case FETCH_REQUEST:
      return { ...state, loading: true }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: action.errors,
      }
    case CREATE_REQUEST:
      return { ...state, creating: true }
    case CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
        errors: [],
      }
    case CREATE_FAILURE:
      return {
        ...state,
        creating: false,
        errors: action.errors,
      }
    case UPDATE_REQUEST:
      return { ...state, updating: true }
    case UPDATE_SUCCESS:
      return {
        ...state,
        updating: false,
        errors: [],
      }
    case UPDATE_FAILURE:
      return {
        ...state,
        updating: false,
        errors: action.errors,
      }
    case DELETE_REQUEST:
      return { ...state, deleting: true }
    case DELETE_SUCCESS:
      return {
        ...state,
        deleting: false,
        errors: [],
      }
    case DELETE_FAILURE:
      return {
        ...state,
        deleting: false,
        errors: action.errors,
      }
    case SELECT_TASKLISTITEM:
      return { ...state, selectedId: action.selectedId }
    default:
      return state
  }
}
